import axios from "axios";
import { refreshSession } from "./authClient";

const API_BASE = process.env.REACT_APP_API_URL || "";

const profileClient = axios.create({
    baseURL: API_BASE,
    withCredentials: true
});

// Add response interceptor for 401 handling
profileClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                await refreshSession();
                return profileClient(originalRequest);
            } catch (refreshError) {
                window.location.href = "/login";
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export async function getProfile() {
    const resp = await profileClient.get('/api/profile');
    return resp.data;
}

export async function updateProfile(data) {
    const resp = await profileClient.put('/api/profile', data);
    return resp.data;
}

export async function getPreferences() {
    const resp = await profileClient.get('/api/profile/preferences');
    return resp.data;
}

export async function updatePreferences(updates) {
    const resp = await profileClient.patch('/api/profile/preferences', updates);
    return resp.data;
}
